var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class PatchPsps {
  constructor(_data) {
    /**
     */
    __publicField(this, "AddedPsps");
    /**
     */
    __publicField(this, "RemovedPsps");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof PatchPsps
     */
    __publicField(this, "$type", "V1.Account.PatchPsps");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["AddedPsps"] && _data["AddedPsps"].constructor === Array) {
        this.AddedPsps = [];
        for (let item of _data["AddedPsps"]) {
          this.AddedPsps.push(item);
        }
      }
      if (_data["RemovedPsps"] && _data["RemovedPsps"].constructor === Array) {
        this.RemovedPsps = [];
        for (let item of _data["RemovedPsps"]) {
          this.RemovedPsps.push(item);
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.AddedPsps && this.AddedPsps.constructor === Array) {
      _data["AddedPsps"] = [];
      for (let item of this.AddedPsps) {
        _data["AddedPsps"].push(item);
      }
    }
    if (this.RemovedPsps && this.RemovedPsps.constructor === Array) {
      _data["RemovedPsps"] = [];
      for (let item of this.RemovedPsps) {
        _data["RemovedPsps"].push(item);
      }
    }
    return _data;
  }
}
